import type { Mission } from '../missions.ts'

export const bop: Mission = {
  id: "bop",
  name: "Federal Bureau of Prisons",
  short: "BOP",
  call: "Corrections",
  kind: "subagency",
  parent: "doj",
  url: "https://www.bop.gov/",
  established: 1930,
  palette: {
    primary: "#002b70",
    secondary: "#532804",
    accent: "#fed63d",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Bureau_of_Prisons.svg",
  },
  motif: "key",
  mission: {
    text: "It is the mission of the Federal Bureau of Prisons to protect society by confining offenders in the controlled environments of prisons and community-based facilities that are safe, humane, cost-efficient, and appropriately secure, and that provide work and other self-improvement opportunities to assist offenders in becoming law-abiding citizens.",
    url: "https://www.bop.gov/about/agency/agency_pillars.jsp",
  },
  fact: {
    text: "Congress established the Federal Bureau of Prisons on May 14, 1930, to manage the 11 federal prisons then in operation.",
    url: "https://www.bop.gov/about/history/",
  },
  seal: {
    file: "public/seals/bop.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Bureau_of_Prisons.svg",
  },
  identifier: {
    about: "https://www.bop.gov/about/",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.bop.gov/foia/",
    noFear: "https://www.bop.gov/website/nofearact.jsp",
    oig: "https://oig.justice.gov/",
    performance: "https://www.bop.gov/about/agency/budget_and_performance.jsp",
    privacy: "https://www.bop.gov/website/privacy_policy.jsp",
  },
  media: {
    photos: [
      {
        file: "/media/bop-usp-lee.jpg",
        small: "/media/bop-usp-lee-sm.jpg",
        alt: "Guard towers and long low buildings of a federal penitentiary stand beyond a green field under a blue sky.",
        title: "United States Penitentiary, Lee, Lee County, Virginia, January 28, 2017",
        creator: "Nyttend",
        source: "https://commons.wikimedia.org/wiki/File:USP_Lee_from_southeast.jpg",
        license: "Public domain (released by the creator)",
      },
      {
        file: "/media/bop-fci-sheridan.jpg",
        small: "/media/bop-fci-sheridan-sm.jpg",
        alt: "Aerial view of a federal correctional institution with red-roofed buildings and a perimeter road, surrounded by farmland and low clouds.",
        title: "Federal Correctional Institution, Sheridan, Oregon, from above, November 9, 2024",
        creator: "Tedder",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Correctional_Institution_Sheridan_overhead_view.jpg",
        license: "CC BY 4.0",
      },
    ],
  },
}
